import { defineMessages } from 'react-intl';

export default defineMessages({
  connectLoadingErrorTitle: {
    id: 'frontbucket.repository.source.connect.loadingErrorTitle',
    description: 'Title heading for connect loading error',
    defaultMessage: 'Your app failed to load',
  },
  connectLoadingErrorDescription: {
    id: 'frontbucket.repository.source.connect.loadingErrorDescription',
    description: 'Title description for connect loading error',
    defaultMessage:
      'Something went wrong when we tried to load the app {appName}.',
  },
});
